import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPerson = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 20,
	fill: "none",
	viewBox: "0 0 17 17",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M6.7 3.5c.2-.3.7-.5 1.3-.5.4 0 .7 0 1 .2l.6.6.2 1.2c0 .8-.2 1.2-.5 1.5-.3.3-.7.5-1.3.5a2 2 0 0 1-1-.2 1.5 1.5 0 0 1-.6-.6L6.2 5c0-.8.2-1.3.5-1.5zM8 1c-1 0-2 .3-2.8 1a4 4 0 0 0-1 3c0 .8.1 1.5.5 2.1A3.5 3.5 0 0 0 6 8.5 4 4 0 0 0 8 9c1 0 2-.3 2.8-1a4 4 0 0 0 1-3c0-.8-.1-1.5-.5-2.1A3.5 3.5 0 0 0 10 1.5C9.4 1 8.7 1 8 1zM2.5 13.9a3.3 3.3 0 0 1 1.3-1.4C4.3 12.2 5 12 6 12h4c1 0 1.7.2 2.2.5.6.3 1 .8 1.3 1.4.3.5.5 1.3.5 2.1v1h2v-1c0-1.1-.2-2.1-.7-3a5.3 5.3 0 0 0-2-2.2c-1-.6-2-.8-3.3-.8H6c-1.1 0-2.3.2-3.2.8a5.3 5.3 0 0 0-2.1 2.1C.2 14 0 15 0 16v1h2v-1c0-.8.2-1.6.5-2.1z",
		clipRule: "evenodd"
	})
});
export default SvgPerson;
